import io from "socket.io-client";

export default {

    data() {
        return {
            //进入该页面从数据库里面获取当前视频看的时间
            sqlCurrentTime: 0,
            //根据websocket来判断是否需要启动离开视频是否需要获取
            isGetVideo: '',
            // websocket
            ws: null,
            //进度信息保存的定时器
            saveProcessInfo: null,
            //看完后保存一个时间
            endingTime: 0,
            //现在播放的最长时间，显示在右上角
            nowLongTime: 0,
            //获取现在课程播放时间
            nowTime: 0,
            //获取课程总时间
            sumTime: 0,
            // isImg: true,
            //右侧弹出的箭头图标改的标识
            arrowIcon: true,
            //考试id
            testId: '',
            //章节索引
            chapterIndex: '',
            //课时索引
            classIndex: '',
            //课时名字
            className: '',
            //课程详情
            classDetails: {},
            //获取现在播放时间的定时器
            timer: null,
            //视频vid
            videoUrl: '',
            //视频对象
            videoObj: '',
            // //视频的vid
            // url: '',
            //视频的章节资源
            resources: [],
            src: require('../../assets/images/arrows-right.png'),
        }

    },
    methods: {
        //弹出章节目录
        displayChapter: function () {
            let percent = ((document.body.offsetWidth - 350) / document.body.offsetWidth) * 100;
            document.querySelector('body').style.cssText = `width:${percent}%;position:relative;left:0.001%;transition: all 350ms;`;
        },

        //回课程学习页面
        toClassStudy: function () {
            this.$router.push({
                path: '/classstudy',
                query: {
                    id: this.$route.query.id,
                    purchased_id: this.$route.query.orderGoodsId
                }
            })
        },
        //去课后习题页面
        toClassExam: function () {
            UIkit.offcanvas(document.querySelector('#offcanvas-push')).hide();
            let address = this.$router.resolve({
                path: '/classexam',
                query: {
                    id: this.testId,
                    goodsId: this.$route.query.goodsId
                }
            });
            window.open(address.href, '_blank');
        },
        //获取视频页面的数据
        getData: function () {
            // 设置定时器30秒发送一次保存数据库的请求
            this.saveProcessInfo = setInterval(() => {
                this.otherLeaveVideo();
            }, 300000)
            this.chapterIndex = this.$route.query.chapterIndex;
            this.classIndex = this.$route.query.classIndex;
            this.className = this.$route.query.className;
            let me = this;
            //获取课程的视频章节信息
            if (this.$route.query.isRate.toString() == 'true') {
                this.$post('orders/search', { token: this.$store.state.id, offset: 0, length: '999' }).then(res => {
                    return res.data.result.data;
                }).then(data => {
                    for (let val of data) {
                        (function () {
                            me.$post('purchased/search', { token: me.$store.state.id, order_id: val.id, offset: 0, length: '999' }).then(res => {
                                for (let item of res.data.result.data) {
                                    if (Number.parseInt(me.$route.query.goodsId) == Number.parseInt(item.product_id) && val.state == 2) {
                                        me.$post('products/get', { id: me.$route.query.id, token: me.$store.state.id }).then(res => {
                                            return res.data.result.project_id;
                                        }).then(id_data => {
                                            me.$post('projects/search', { id: id_data, token: me.$store.state.id }).then(res => {
                                                let testObj = JSON.parse(res.data.result.resources).pop().items[0].resources;
                                                //判断是否有题目，若有题目则获取题目id，否则让题目满分
                                                if (!testObj || testObj == '' || testObj == null || testObj == undefined) {
                                                    me.$post('purchased/sumbitResult', { id: item.id, private: JSON.stringify({}), token: me.$store.state.id, score: 100 }).then(res => {
                                                        // // console.log(res.data.result);
                                                    })
                                                } else {
                                                    me.testID = testObj[0];
                                                }
                                            });
                                        })

                                        me.resources = JSON.parse(item.rate).resources;
                                        for (let val of me.resources[0].items) {
                                            if (me.$route.query.className == val.name) {
                                                if (val.currentTime && val.currentTime != undefined) {
                                                    me.sqlCurrentTime = Number.parseFloat(val.currentTime);
                                                } else {
                                                    me.sqlCurrentTime = 0;
                                                }
                                            }
                                        }
                                    }
                                }
                            })
                        })(val)
                    }
                })
            } else {
                this.$post('products/get', { id: this.$route.query.id, token: me.$store.state.id }).then(res => {
                    return res.data.result.project_id;
                }).then(id_data => {
                    this.$post('projects/search', { id: id_data, token: this.$store.state.id }).then(res => {
                        this.resources = JSON.parse(res.data.result.resources);
                        this.resources.id = this.$route.query.id;
                        let testObj = this.resources.pop().items[0].resources;
                        //判断是否有题目，若有题目则获取题目id，否则让题目满分
                        if (!testObj || testObj == '' || testObj == null || testObj == undefined) {
                            this.$post('purchased/sumbitResult', { id: item.id, private: JSON.stringify({}), token: this.$store.state.id, score: 100 }).then(res => {
                                // // console.log(res.data.result);
                            })
                        } else {
                            this.testID = testObj[0];
                        }

                    });
                })
            }

            //获取课程的基本信息
            this.$post('products/get', { id: this.$route.query.classId }).then(res => {
                this.classDetails = res.data.result;
            })
        },
        //点击视频章节切换不同视频
        toLearnVideo: function (resources, chapterIndex, classIndex, className, currentTime, allTime) {
            //离开页面让学习页面刷新进度
            this.nowLongTime = 0;
            this.sumTime = 0;
            this.nowTime = 0;
            if (currentTime && currentTime / allTime == 1) {
                UIkit.modal(document.querySelector('#modal-no-look')).show();
                return
            } else {
                let time = 0;
                let resources_url = '';
                currentTime ? time = currentTime : time = 0;
                this.chapterIndex = chapterIndex;
                this.classIndex = classIndex;
                this.leaveVideo();
                this.$post('resources/get', { id: resources[0], token: this.$store.state.id }).then(res => {
                    resources_url = res.data.result.data;
                    this.videoPlay(resources_url, time);
                    this.className = className;
                    document.title = className;
                    UIkit.offcanvas(document.querySelector('#offcanvas-push')).hide();
                })
            }
        },
        //创建保利威视的视频对象
        videoPlay: function (url, time) {
            let currentTime = time;
            let numVal = ((1 - 140 / document.body.offsetHeight));
            let eleHeight = document.body.offsetHeight * numVal;
            let isAuth = this.$route.query.isAuth;
            let isPlayer = 'on';
            let me = this;
            this.videoUrl = url;
            currentTime ? currentTime : currentTime = 0;
            isAuth == '1' ? isPlayer : isPlayer = 'off';
            var player = polyvObject(
                "#plv_1"
            ).videoPlayer({
                width: 800,
                height: [eleHeight],
                vid: url,
                'flashvars': { "watchStartTime": currentTime, "ban_seek_by_limit_time": isPlayer, 'ban_history_time': 'on' }
            });
            this.videoObj = player;
            //计算上面视频右上角的定时器
            this.nowTime = this.timeResult(currentTime);
            this.timer = setInterval(function () {
                let baoliTime = me.videoObj.j2s_getCurrentTime();
                baoliTime >= me.nowLongTime ? me.nowLongTime = baoliTime : me.nowLongTime;
                me.nowTime = me.timeResult(Math.max(baoliTime, me.nowLongTime));
                me.sumTime = me.timeResult(me.videoObj.j2s_getDuration());
            }, 1000)
        },
        //返回00时00分00秒格式
        timeResult: function (time) {
            let secondTime = Number.parseInt(time);
            let minuteTime = 0;
            let hourTime = 0;
            let result = '';
            if (time > 60) {
                minuteTime = Number.parseInt(time / 60);
                secondTime = Number.parseInt(time % 60);
                if (minuteTime > 60) {
                    hourTime = Number.parseInt(minuteTime / 60);
                    minuteTime = Number.parseInt(minuteTime % 60);
                }
            }
            hourTime >= 10 ? result += hourTime + '时' : result += '0' + hourTime + '时';
            minuteTime >= 10 ? result += minuteTime + '分' : result += '0' + minuteTime + '分';
            secondTime >= 10 ? result += secondTime + '秒' : result += '0' + secondTime + '秒';
            return result;
        },
        //另一个触发方法
        otherLeaveVideo: function () {
            if (this.resources.length == 0) {
                return;
            }
            let obj = {};
            let resources = this.resources;
            let progress = 0;
            let chapter = resources.length;
            let sumClassTime = 0;
            let finishTime = 0;
            let nowTime = 0;
            //获取最大进度时间的值
            if (this.$route.query.currentTime) {
                nowTime = Math.max(Number.parseInt(this.$route.query.currentTime), this.videoObj.j2s_getCurrentTime(), this.endingTime, this.sqlCurrentTime);
            } else {
                nowTime = Math.max(this.videoObj.j2s_getCurrentTime(), this.endingTime, this.sqlCurrentTime);
            }
            //用来保存继续学习的数据
            let continueClass = {
                chapterIndex: this.chapterIndex,
                classIndex: this.classIndex,
                className: this.className,
                currentTime: nowTime,
                items_resources: this.videoUrl,
                allTime: this.videoObj.j2s_getDuration(),
            };
            //循环计算总进度（按课时）/（按时间）
            for (let val of resources) {
                let joint = val.items.length;
                for (let v of val.items) {
                    sumClassTime += 1;
                    //判断如果是当前课程的话，就添加已经看的时间和总的时间
                    if (v.name == this.className) {
                        v.currentTime = nowTime;
                        v.allTime = this.videoObj.j2s_getDuration();
                    }
                    if (v.currentTime) {
                        v.currentTime >= v.allTime ? finishTime += 1 : finishTime;
                        progress += (v.currentTime / v.allTime / joint / chapter);
                    }
                }
            };
            //总进度=》按章节课程时长
            obj.classProgress = finishTime / sumClassTime;
            //章节资源。里面有章节时长和章节总时间
            obj.resources = resources;
            //考试id
            obj.testId = this.testId;
            //订单的商品id
            obj.orderGoodsId = this.$route.query.orderGoodsId;
            //若时间大于1则按照1输入，否则会出错
            progress > 1 ? progress = 1 : progress;
            //总进度=》按已看时长
            obj.progress = progress;
            //己住上传观看的课时
            obj.continueClass = continueClass;
            this.$post('purchased/sumbitRate', { id: obj.orderGoodsId, rate: JSON.stringify(obj), progress: obj.classProgress, token: this.$store.state.id }).then(res => {
            })
        },
        //离开页面或者关闭浏览器触发请求
        leaveVideo: function () {
            if (this.isGetVideo == 'false' || this.resources.length == 0) {
                return;
            }
            // this.$root.isGetData=true;
            // alert(this.$root.isGetData=true);
            //离开页面让学习页面刷新进度

            //关掉视频时间的计时器
            clearInterval(this.timer);
            //关闭储存进度的定时器
            clearInterval(this.saveProcessInfo);
            //章节目录侧边栏隐藏
            UIkit.offcanvas(document.querySelector('#offcanvas-push')).hide();
            let obj = {};
            let resources = this.resources;
            let progress = 0;
            let chapter = resources.length;
            let sumClassTime = 0;
            let finishTime = 0;
            let nowTime = 0;
            //获取最大进度时间的值
            if (this.$route.query.currentTime) {
                nowTime = Math.max(Number.parseInt(this.$route.query.currentTime), this.videoObj.j2s_getCurrentTime(), this.endingTime, this.sqlCurrentTime);
            } else {
                nowTime = Math.max(this.videoObj.j2s_getCurrentTime(), this.endingTime, this.sqlCurrentTime);
            }
            //用来保存继续学习的数据
            let continueClass = {
                chapterIndex: this.chapterIndex,
                classIndex: this.classIndex,
                className: this.className,
                currentTime: nowTime,
                items_resources: this.videoUrl,
                allTime: this.videoObj.j2s_getDuration(),
            };
            //循环计算总进度（按课时）/（按时间）
            for (let val of resources) {
                let joint = val.items.length;
                for (let v of val.items) {
                    sumClassTime += 1;
                    //判断如果是当前课程的话，就添加已经看的时间和总的时间
                    if (v.name == this.className) {
                        v.currentTime = nowTime;
                        v.allTime = this.videoObj.j2s_getDuration();
                    }
                    if (v.currentTime) {
                        v.currentTime >= v.allTime ? finishTime += 1 : finishTime;
                        progress += (v.currentTime / v.allTime / joint / chapter);
                    }
                }
            }
            //总进度=》按章节课程时长
            obj.classProgress = finishTime / sumClassTime;
            //已经学的时长
            obj.finishTime = finishTime;
            //总时长
            obj.sumClassTime = sumClassTime;
            //章节资源。里面有章节时长和章节总时间
            obj.resources = resources;
            //考试id
            obj.testId = this.testId;
            //订单的商品id
            obj.orderGoodsId = this.$route.query.orderGoodsId;
            //若时间大于1则按照1输入，否则会出错
            progress > 1 ? progress = 1 : progress;
            //总进度=》按已看时长
            obj.progress = progress;
            //己住上传观看的课时
            obj.continueClass = continueClass;
            this.$post('purchased/sumbitRate', { id: obj.orderGoodsId, rate: JSON.stringify(obj), progress: obj.classProgress, token: this.$store.state.id }).then(res => {

            })
        },


    },

    //离开视频页面时候存储JSON信息到rate字段
    beforeRouteLeave: function (to, from, next) {
        this.ws.close();
        this.leaveVideo();
        next();
    },
    created: function () {
        window.onbeforeunload = () => {
            this.leaveVideo();
        }
    },
    mounted: function () {
        let me = this;
        UIkit.util.on('#modal-studying', 'hidden', function () {
            me.$router.push({
                path: '/classstudy',
                query: {
                    id: me.$route.query.id,
                    purchased_id: me.$route.query.orderGoodsId
                }
            })
        });
        if ("WebSocket" in window) {
            let id = this.$store.state.userId;
            this.ws = io("wss://teach-websocket.ca163.com?id=" + id + '&policy=2');
            // var ws = new WebSocket("ws://192.168.31.98:8765/websocket?id=" + id + '&policy=2');
            
            this.ws.on('connect', () => {
                console.log('socket已连接...');
                
                me.isGetVideo = 'true';
                //获取数据
                me.getData();
                //进入页面获取视频资源
                me.videoPlay(me.$route.query.items_resources, me.$route.query.currentTime);
                //页面标题
                document.title = this.$route.query.className;
                //关闭章节目录栏触发下面的方法使得视频大小恢复
                UIkit.util.on('#offcanvas-push', 'hide', function () {
                    me.arrowIcon = !me.arrowIcon;
                    document.querySelector('body').style.cssText = 'width:100%;transition: all 350ms;';
                });
                //打开章节目录改变箭头图标
                UIkit.util.on('#offcanvas-push', 'show', function () {
                    me.arrowIcon = !me.arrowIcon;
                });
                document.querySelector('body').style.cssText = 'width:100%;transition: all 350ms;';
                //如果视频播放结束就执行这行代码获取总时间
                window.s2j_onPlayOver = () => {
                    this.endingTime = this.videoObj.j2s_getDuration();
                    this.otherLeaveVideo()
                }
            });
            
            this.ws.on('disconnect', () => {
                // socket断开连接，
                // 学员在同时学习，提示后返回课程页面
                me.isGetVideo = 'false';
                UIkit.modal(document.querySelector('#modal-studying')).show();
            });
            // ws.onmessage = (evt) => {
            //     // // console.log(JSON.parse(evt.data).success);
            //     if (JSON.parse(evt.data).success == 'true') {
            //         me.isGetVideo = 'true';
            //         //获取数据
            //         me.getData();
            //         //进入页面获取视频资源
            //         me.videoPlay(me.$route.query.items_resources, me.$route.query.currentTime);
            //         //页面标题
            //         document.title = this.$route.query.className;
            //         //关闭章节目录栏触发下面的方法使得视频大小恢复
            //         UIkit.util.on('#offcanvas-push', 'hide', function () {
            //             me.arrowIcon = !me.arrowIcon;
            //             document.querySelector('body').style.cssText = 'width:100%;transition: all 350ms;';
            //         });
            //         //打开章节目录改变箭头图标
            //         UIkit.util.on('#offcanvas-push', 'show', function () {
            //             me.arrowIcon = !me.arrowIcon;
            //         });
            //         document.querySelector('body').style.cssText = 'width:100%;transition: all 350ms;';
            //         //如果视频播放结束就执行这行代码获取总时间
            //         window.s2j_onPlayOver = () => {
            //             this.endingTime = this.videoObj.j2s_getDuration();
            //             this.otherLeaveVideo()
            //         }
            //     } else {
            //         me.isGetVideo = 'false';
            //         UIkit.modal(document.querySelector('#modal-studying')).show();
            //     }
            // };
        }




    },

}
